import { lazy, Suspense } from 'react';
import { LoadingSpinner } from './loading-spinner';

const PdfThumbnailClientLazy = lazy(() =>
  import('./pdf-components.client').then((mod) => ({ default: mod.PdfThumbnail }))
);

const PdfViewerClientLazy = lazy(() =>
  import('./pdf-components.client').then((mod) => ({ default: mod.PdfViewer }))
);

/** @lintignore */
export function PdfThumbnail({ fileUrl }: { fileUrl: string }) {
  return (
    <Suspense
      fallback={
        <div className="relative flex items-center justify-center w-8 h-8 bg-muted rounded-sm border border-border">
          <LoadingSpinner size="sm" />
        </div>
      }
    >
      <PdfThumbnailClientLazy fileUrl={fileUrl} />
    </Suspense>
  );
}

export function PdfViewer({ fileUrl }: { fileUrl: string }) {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-full">
          <LoadingSpinner size="lg" />
        </div>
      }
    >
      <PdfViewerClientLazy fileUrl={fileUrl} />
    </Suspense>
  );
}
